export default __webpack_public_path__ + "static/media/DUSTY_1.e0380937.gif";